import { useLazyQuery } from '@apollo/client/react';

import {
  MdStoreFilterInput,
  MdStoreSortByFieldEnum,
  useLoadOptions,
  MdStoresSelectQuery,
  MdStoresSelectQueryVariables,
} from '@anyx/common-graphql';


import { STORES_SELECT } from '../graphql';

export type MultiQuery = useLazyQuery.Options<MdStoresSelectQuery, MdStoresSelectQueryVariables>;

export const useStoresSelect = <T = string>({ filters }: { filters?: MdStoreFilterInput }) => {
  const [queryMdStoreList] = useLazyQuery(STORES_SELECT);
  const { loadOptions } = useLoadOptions<
    MdStoresSelectQuery['MdStores']['items'][0],
    T,
    Omit<MdStoresSelectQuery, '__typename'>,
    MdStoresSelectQueryVariables
  >({
    labelFormatter: (item) => item.name,
    valueFormatter: (item) => item.id as unknown as T,
    listQuery: {
      variables: {
        sortBy: {
          descending: false,
          field: MdStoreSortByFieldEnum.NAME,
        },
        filter: {
          ...filters,
        },
      },
      scope: 'MdStores',
      lazyQuery: queryMdStoreList,
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } as any,
  });
  return {
    loadOptions,
  };
};
